<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Настройка уведомлений</T>
      <div style="font-size: 0.85rem; color: gray;">
        <T>Только для онлайн заказов</T>
      </div>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-295"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="dis"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>

    <NotificationsSettings
     :config="$store.getters.local_refs.notifications_settings"
     ref="notifications_settings"
    />

  </div>
</template>
  
  <script>
  
  import Teleport from 'vue2-teleport'
  import NotificationsSettings from '../../components/settings/notifications'
  
  
  export default {
    data: () => ({
      loading: false,
      dis: false
    }),
    methods: {
      async save(){
        this.loading = true
        try {
          let new_config = {
            notifications_settings: this.$refs.notifications_settings.submit()
          }
          
          await this.$store.dispatch('updateLocalRefs', new_config)
  
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: this.$t('Изменения сохранены'),
            message_class: 'success'
          })
  
        } catch (e) {
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: `${e.message}`,
            message_class: 'error'
          })
          this.loading = false
        } finally {
          this.loading = false
        }
      }
    },

    components: {
      Teleport,
      NotificationsSettings
    }
  }
  </script>


